import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Header, Button, Image } from 'semantic-ui-react';
import EmployeeStore from "../../../app/stores/employeeStore";

interface IProps {
  email: string;
}

const dropzoneStyles = {
  // border: 'dashed 3px',
  // borderColor: 'transparent',
  // borderRadius: '5px',
  // paddingTop: '30px',
  textAlign: 'center' as 'center',
  // height: '50px'
};

const dropzoneActive = {
  border: 'dashed 3px',
  borderRadius: '5px',
  borderColor: 'green'
};



const EmployeePhotoDropzone: React.FC<IProps> = ({ email }) => {
  const employeeStore = useContext(EmployeeStore);
  const {uploadEmployeePhoto} = employeeStore;

// const [files, setFiles] = useState<File[]>([]);

  const onDrop = useCallback(acceptedFiles => {
    uploadEmployeePhoto(acceptedFiles, email);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: 'image/jpeg, image/png', maxFiles: 1 });

  return (
    <section>
      <div
        {...getRootProps()}
        style={ 
          isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
        }
      >
        <input {...getInputProps()} />
        {/* <Icon name='upload' size='big' /> */}
        <Image
          size='small'
          src="/assets/addphoto.png"
        />
        {/* <Header content='Click here' /> */}

      </div>
      {/* <ul>{files}</ul> */}

    </section>
  );
};

export default EmployeePhotoDropzone;
